import { DownloadOutlined } from "@ant-design/icons";
import { Row } from "antd";
import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Button from "../../../../../../components/functional_components/Button/PFButton";
import { setLoading } from "../../../../../../redux/ducks/Loading";
import ProjectInvoicePlan from "../../../../../../services/api/ProjectInvoicePlan";
import { fileFormatXextension } from "../../../../../../utils/properties";
import { exportFile, showError, showSuccess } from "../../../../../../utils/utilities";
import BillingTable from "./BillingTable";
import ProductionTable from "./ProductionTable";

const BillingPlan = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const refreshData = useSelector((state) => state.billingPlanManagementDuck.refreshData);
  const params = useParams();
  const [state, setState] = useState({
    downloadLoading: false,
    alert: false,
    closed: false,
    consValueOpenMonth: 0,
    openMonth: "",
    columnsInvoicePlan: [],
    allData: {},
    tableContentInvoicePlan: {},
    tableContentProductionValue: [],
    list: {},
  });

  useEffect(() => {
    if (refreshData || refreshData === null) {
      dataList();
    }
  }, [refreshData]);

  const dataList = async () => {
    dispatch(setLoading(true));
    const data = await ProjectInvoicePlan.getDataProjectInvoicePlan(params.id);
    if (!data.error && data.data) {
      let dataBilling = [];
      let dataProduction = [];
      data.data.values.forEach((row, i) => {
        row.key = i;
        if (i <= 2) {
          dataBilling.push(row);
        } else {
          dataProduction.push(row);
        }
      });
      setState((prevState) => ({
        ...prevState,
        allData: data.data,
        tableContentInvoicePlan: dataBilling,
        tableContentProductionValue: dataProduction,
      }));
    } else {
      showError(get(data, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const handleExport = async () => {
    setState((prevState) => ({ ...prevState, downloadLoading: true }));
    const exportResponse = await ProjectInvoicePlan.downloadProjectInvoicePlan(params.id);
    if (!exportResponse.error) {
      const downloadType = fileFormatXextension["xlsx"];
      const blob = new Blob([exportResponse], { type: downloadType });
      exportFile(blob, `${t("projectsManagement.planning.billingPlan.INVOICE_PLAN")}.xlsx`);
      showSuccess();
    } else {
      showError(get(exportResponse, "error.messageCode", "ER000"));
    }
    setState((prevState) => ({ ...prevState, downloadLoading: false }));
  };

  return (
    <>
      <Row type="flex" align="middle" justify="end" className="mb-10">
        <Button
          isLoading={state.downloadLoading}
          currentIcon={<DownloadOutlined className="icon-large" />}
          clickCallback={handleExport}
        />
      </Row>
      {!isEmpty(state.tableContentInvoicePlan) && (
        <BillingTable dataContentBilling={state.tableContentInvoicePlan} allData={state.allData} />
      )}
      {!isEmpty(state.tableContentProductionValue) && (
        <ProductionTable dataContentProduction={state.tableContentProductionValue} allData={state.allData} />
      )}
    </>
  );
};

export default BillingPlan;
